module.exports = __webpack_public_path__ + "media/images/matching-a-389be5ffe652b9e26804168e93903ff8.png";